import { render, staticRenderFns } from "./SettingsProfile.vue?vue&type=template&id=0d11d3b0&scoped=true&"
import script from "./SettingsProfile.vue?vue&type=script&lang=js&"
export * from "./SettingsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d11d3b0",
  null
  
)

export default component.exports